import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import React from 'react';
import GoogleIcon from './static/GoogleIcon.png';

type GoogleButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text?: string;
  width?: string;
};

export const NewGoogleButton: React.FC<GoogleButtonProps> = ({
  onClick,
  text = 'Login',
  width = '100%',
}) => {
  return (
    <button
      onClick={onClick}
      className={css`
        border-radius: 76px;
        background: ${theme.colors.text['highlight/3']};
        max-width: 340px;
        width: ${width};
        height: 48px;
        cursor: pointer;
        color: ${theme.colors.text.dark};

        font-family: ${theme.font.button.fontFamily};
        font-size: ${theme.font.button.fontSize};
        font-style: normal;
        font-weight: 900;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 24px;
      `}
    >
      <img
        src={GoogleIcon}
        alt="Google Icon"
        style={{ width: '24px', height: '24px', marginRight: '16px' }}
      />
      {text}
    </button>
  );
};
